import { BE_ACCESS_TOKEN_LOCALSTORAGE_KEY } from 'hooks/useCurrentUser'

function getAflToken(): string | null {
  try {
    const creds = JSON.parse(
      localStorage.getItem(BE_ACCESS_TOKEN_LOCALSTORAGE_KEY) || '{}'
    )
    return creds?.accessToken ?? null
  } catch {
    return null
  }
}

export const getPinnedMoments = async () => {
  try {
    const token = getAflToken()
    if (!token) return []
    const raw = await fetch(
      `${import.meta.env.VITE_BACKEND_URL}/api/pinned-moments`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`
        }
      }
    )
    const response = await raw.json()
    return response?.nftIds ?? []
  } catch (error) {
    return []
  }
}

export const upsertPinnedMoments = async (ids: string[]) => {
  const token = getAflToken()
  if (!token) return
  const raw = await fetch(
    `${import.meta.env.VITE_BACKEND_URL}/api/pinned-moments`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ nftIds: ids })
    }
  )
  const response = await raw.json()
  return response?.nftIds
}
